import { render } from "./IdentityDocuments.vue?vue&type=template&id=08e33fae"
import script from "./IdentityDocuments.vue?vue&type=script&lang=js"
export * from "./IdentityDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__